import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

const CONFIG_DEFAULTS: RemoteConfig.ConfigValues = {
  footer_download_app_icons_enabled: true,
  google_login_button_enabled: true,
  delete_account_enabled: false,
};

interface ConfigState {
  values: RemoteConfig.ConfigValues;
}

const initialState: ConfigState = {
  values: CONFIG_DEFAULTS,
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<RemoteConfig.ConfigValues>) {
      state.values = action.payload;
    },
  },
});

export const { setConfig } = configSlice.actions;

export const selectConfig = (state: RootState) => state.config.values;

export default configSlice.reducer;
